;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"8c76c4b14ed63012b84c42f7e31cd8cbca759286-test"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.4";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/data-terms-of-service\"},{\"path\":\"/help-center\"},{\"path\":\"/help-center/how-are-prices-determined\"},{\"path\":\"/help-center/market-outcomes\"},{\"path\":\"/help-center/market-rules\"},{\"path\":\"/help-center/orderbook\"},{\"path\":\"/ipl-terms\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/\"},{\"path\":\"/event\"},{\"path\":\"/im\"},{\"path\":\"/leaderboard\"},{\"path\":\"/live\"},{\"path\":\"/main-event-detail\"},{\"path\":\"/me\"},{\"path\":\"/search\"},{\"path\":\"/profile\"},{\"path\":\"/profile/edit\"},{\"path\":\"/profile/social\"},{\"path\":\"/event-preview\"},{\"path\":\"/deposit\"},{\"path\":\"/transactions\"},{\"path\":\"/transfer\"},{\"path\":\"/transfer/deposit\"},{\"path\":\"/transfer/withdraw\"},{\"path\":\"/withdraw\"},{\"path\":\"/event-detail\"},{\"path\":\"/guide\"},{\"path\":\"/ipl-compaign\"},{\"path\":\"/notifications\"},{\"path\":\"/notifications/announcements\"},{\"path\":\"/notifications/announcements/detail\"},{\"path\":\"/order-guess-detail\"},{\"path\":\"/portfolio\"},{\"path\":\"/single-guess-detail\"},{\"path\":\"/sport-event-detail\"},{\"path\":\"/watchlist\"}],\"isrRoutes\":[]}";import {
    createSentryBeforeBreadcrumb,
    createSentryBeforeSend,
    getSentryTracePropagationTargets,
} from "@/lib/sentry/instrument";
import * as Sentry from "@sentry/nextjs";

const isProd = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === "production";

Sentry.init( {
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,

    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

    integrations: [
        /**
         * Browser Tracing
         * 自动追踪：
         * - pageload
         * - navigation
         * - fetch/xhr
         * - web vitals
         */
        Sentry.browserTracingIntegration(),

        /**
         * 去重
         */
        Sentry.dedupeIntegration(),

        /**
         * Session Replay（推荐）
         */
        Sentry.replayIntegration( { maskAllText: true, blockAllMedia: true } ),
    ],

    /**
     * Error 采样
     * 一般保持 1 即可
     */
    sampleRate: 1,

    /**
     * Tracing 采样
     *
     * 测试环境全量采样
     * 生产环境低采样
     */
    tracesSampleRate: isProd ? 0.05 : 1,

    /**
     * Replay 采样
     */
    replaysSessionSampleRate: isProd ? 0.05 : 1,

    /**
     * Error Replay
     * 出错时强制录制
     */
    replaysOnErrorSampleRate: 0.05,

    /**
     * 哪些请求允许 trace header 透传
     */
    tracePropagationTargets: getSentryTracePropagationTargets(),

    /**
     * 默认不上传 PII
     * 避免 GDPR 风险
     */
    sendDefaultPii: false,

    beforeBreadcrumb: createSentryBeforeBreadcrumb(),

    beforeSend: createSentryBeforeSend(),
} );

/**
 * 全局业务标签
 */
Sentry.setTag( "app", "predik-next" );

Sentry.setTag( "env", process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || "unknown" );

/**
 * App Router Tracing
 *
 * Sentry v10 官方方案
 */
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
